import { useT } from "@/i18n";

export const Logo = ({ className = "" }) => {
  const { t } = useT();
  return (
    <span className={`flex items-center gap-3 ${className}`} data-testid="rb-logo">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md border border-[#C9A84C]/55 p-1.5">
        <img src="/rb-monogram.png" alt="RB Studio" className="h-full w-auto" />
      </span>
      <span className="font-serif text-2xl font-medium uppercase tracking-[0.22em] text-[#1a1a1a] sm:text-[1.7rem]">
        {t("brand.title")}
      </span>
    </span>
  );
};
